
<template>
  <div>
    <b-button
      v-permission="'legal_entities.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <!-- person_type=LE mantém esta tela sendo só de estabelecimentos: sem o filtro
         os profissionais autônomos, que dividem a tabela, apareceriam aqui. -->
    <Grid :css_formats="gridCssFormats()"
          :service="service"
          :forceFilters="{ person_type: 'LE' }"
          route_name="legal_entities">
      <template #gridThead="thead">
        <vs-th
          v-for="(column, key) in thead.data"
          :key="key"
          :sort-key="thead.methods.getColumnSortKey(key)"
          sort-status="asc">{{ $t('establishment.'+thead.methods.getOriginalColumnName(column)) }}</vs-th>
      </template>
      <template #gridData="gridData">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in gridData.data">
          <vs-td
            :data="gridData.data[indextr].id"
            v-for="(column, key) in gridData.columns"
            :key="key">
            <div
              :class="
                gridData.methods.getColumnCss(gridData.data[indextr], key)
              ">
              <div :key="key" v-html-safe="`<div>${gridData.methods.getColumnData(gridData.data[indextr],key)}</div>`"/>
            </div>
          </vs-td>
          <vs-td>
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="`legal_entities.edit`"
                icon="EditIcon"
                class="h-5 w-5 stroke-current text-warning"
                v-if="!hide_edit"
                @click="gridData.edit(gridData.data[indextr].id)"
              />
              <feather-icon
                v-permission="`legal_entities.delete`"
                icon="Trash2Icon"
                class="h-5 w-5 stroke-current text-danger"
                v-if="!hide_delete"
                @click="gridData.destroy(gridData.data[indextr])"
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton, BDropdown, BDropdownItem } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LegalEntityService from '@/services/api/LegalEntityService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
  },
  data: () => ({
    selected: [],
    service: null,
  }),
  computed: {

  },
  methods: {
    gridCssFormats() {
      return {
        company_name: (columnData, rawData) => {
          return 'flex flex-row'
        }
      }
    },
    addNew() {
      this.$router.push('/legal_entities/create')
    },
  },
  beforeMount() {
    this.service = LegalEntityService.build(this.$vs)
  },
}
</script>
